export default __webpack_public_path__ + "static/media/projTrack6Full.7a3bd52a.png";